

import { message } from "antd";
import axios from "axios";

const URL = process.env.REACT_APP_BASE_URL_DEV;
const apiBaseURL = `${URL}/api`;
const instance = axios.create({ baseURL: apiBaseURL, withCredentials: true });
const getAxiosInstance = () => instance;
const handleLogout = () => {
    ["cxs_expiration", "cxs_lastActivityTime"].forEach(
        (key) => localStorage.removeItem(key)
    );
    message.error("Something went wrong. Please login again")
    document.body.innerHTML = "";
    window.location.replace("/");
    // window.location.reload();
};
let isRefreshing = false;
let failedQueue = [];
const processQueue = (error) => {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve();
    });
    failedQueue = [];
};
const forceLogout = async () => {
    try {
        await axios.post(
            `${apiBaseURL}/usermgmt/logoutExpired`,
            {},
            { withCredentials: true }
        );
        handleLogout()
    } catch {
        handleLogout()
    }
};
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (
            error.response?.status === 401 &&
            !originalRequest.retryRequest
        ) {
            if (originalRequest.url?.includes("/LicenseManager/LMrefresh")) {
                processQueue(error);
                await forceLogout();
                return Promise.reject(error);
            }
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => instance(originalRequest));
            }
            originalRequest.retryRequest = true;
            isRefreshing = true;
            try {
                await instance.post("/LicenseManager/LMrefresh");
                processQueue(null);
                return instance(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError);
                await forceLogout();
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);
export { getAxiosInstance };

const URL1 = process.env.REACT_APP_BASE_URL_CRMDEV;
const apiBaseURL1 = `${URL1}/api`;
const instance1 = axios.create({ baseURL: apiBaseURL1 }); // , withCredentials: true 
const getAxiosInstance1 = () => instance1;
// instance1.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//         const originalRequest = error.config;
//         if (
//             error.response?.status === 401 &&
//             !originalRequest.retryRequest
//         ) {
//             if (originalRequest.url?.includes("/LicenseManager/LMrefresh")) {
//                 processQueue(error);
//                 await forceLogout();
//                 return Promise.reject(error);
//             }
//             if (isRefreshing) {
//                 return new Promise((resolve, reject) => {
//                     failedQueue.push({ resolve, reject });
//                 }).then(() => instance(originalRequest));
//             }
//             originalRequest.retryRequest = true;
//             isRefreshing = true;
//             try {
//                 await instance.post("/LicenseManager/LMrefresh");
//                 processQueue(null);
//                 return instance(originalRequest);
//             } catch (refreshError) {
//                 processQueue(refreshError);
//                 await forceLogout();
//                 return Promise.reject(refreshError);
//             } finally {
//                 isRefreshing = false;
//             }
//         }
//         return Promise.reject(error);
//     }
// );
export { getAxiosInstance1 };
